export const SortDirections = {
    ASCENDING: 'asc',
    DESCENDING: 'desc'
}

export const ObjectTypes = {
    GATEWAY: 'gateway',
    CLUSTER_GATEWAY: 'cluster-gateway',
    PLAN: 'plan',
    USER: 'user',
    SYSTEM_USER: 'system-user',
    COMMUNITY: 'community',
    ROLE: 'role',
    SYSTEM_ROLE: 'system-role',
    IMAGE: 'image',
    ADMINISTRATOR: 'administrator',
    FIRMWARE: 'firmware',
    THIS_SERVICE_DOMAIN: 'this-service-domain',
    PORTAL_SETTINGS: 'portal-settings',
    SYSTEM_SETTINGS: 'system-settings',
    SERVICE_DOMAIN: 'service-domain',
    SERVER: 'server',
    SERVER_GROUP: 'server-group',
    SYSTEM_LOGS: 'system-logs',
    ACTIVITY_LOGS: 'activity-logs',
}

export const ApiFunctions = {
    GET: 'get',
    GET_LIST: 'get-list',
    GET_LIST_FROM_DOMAINS: 'get-list-from-domains',
    GET_COUNT: 'get-count',
    CREATE: 'create',
    CLONE: 'clone',
    UPDATE: 'set',
    VERIFY: 'validate-fields',
    DELETE: 'delete',
    GET_ALL_STATUS: 'get-all-status',
    RESET_TO_PLAN: 'reset-to-plan',
    MOVE_TO_PLAN: 'move-to-plan',
    GET_USER_TYPE: 'get-user-type',
    GET_CA_CERT: 'get-ca-cert',
    GET_TEMPLATE_PREVIEW: 'get-template-preview',
    GET_ALERT_PREVIEW: 'get-alert-preview',
    GET_MEMBERS: 'get-members',
    UPDATE_FIRMWARE: 'set-ga',
    UPDATE_FIRMWARE_RECOMMENDED: 'set-recommended'
}

export const ApiPaths = {
    PORTAL: 'portal',
    SYSTEM: 'system',
    LOGS: 'logs',
    GATEWAY: 'gateway',
    CLUSTER_GATEWAY: 'cluster-gateway',
    PLAN: 'plan',
    USER: 'user',
    SYSTEM_USER: 'user',
    COMMUNITY: 'community',
    ROLE: 'role',
    SYSTEM_ROLE: 'role',
    IMAGE: 'image',
    ADMINISTRATOR: 'administrator',
    FIRMWARE: 'firmware',
    SETTINGS: 'settings',
    SERVICE_DOMAIN: 'service-domain',
    SERVER: 'server',
    SERVER_GROUP: 'server-group',
    SYSTEM_LOGS: 'system-logs',
    ACTIVITY_LOGS: 'activity-logs',
    EXCEL: 'excel',
    EXCEL_LOGS: 'excel-logs',
    TOOLS: 'tools'
}


export const objectTypeToApiPath = {
    [ObjectTypes.GATEWAY]: ApiPaths.PORTAL + '/' + ApiPaths.GATEWAY,
    [ObjectTypes.CLUSTER_GATEWAY]: ApiPaths.PORTAL + '/' + ApiPaths.CLUSTER_GATEWAY,
    [ObjectTypes.PLAN]: ApiPaths.PORTAL + '/' + ApiPaths.PLAN,
    [ObjectTypes.USER]: ApiPaths.PORTAL + '/' + ApiPaths.USER,
    [ObjectTypes.COMMUNITY]: ApiPaths.PORTAL + '/' + ApiPaths.COMMUNITY,
    [ObjectTypes.ROLE]: ApiPaths.PORTAL + '/' + ApiPaths.ROLE,
    [ObjectTypes.IMAGE]: ApiPaths.PORTAL + '/' + ApiPaths.IMAGE,
    [ObjectTypes.THIS_SERVICE_DOMAIN]: ApiPaths.PORTAL + '/' + ApiPaths.SERVICE_DOMAIN,
    [ObjectTypes.ADMINISTRATOR]: ApiPaths.SYSTEM + '/' + ApiPaths.ADMINISTRATOR,
    [ObjectTypes.FIRMWARE]: ApiPaths.SYSTEM + '/' + ApiPaths.FIRMWARE,
    [ObjectTypes.PORTAL_SETTINGS]: ApiPaths.PORTAL + '/' + ApiPaths.SETTINGS,
    [ObjectTypes.SYSTEM_SETTINGS]: ApiPaths.SYSTEM + '/' + ApiPaths.SETTINGS,
    [ObjectTypes.SERVICE_DOMAIN]: ApiPaths.SYSTEM + '/' + ApiPaths.SERVICE_DOMAIN,
    [ObjectTypes.SYSTEM_USER]: ApiPaths.SYSTEM + '/' + ApiPaths.SYSTEM_USER,
    [ObjectTypes.SYSTEM_ROLE]: ApiPaths.SYSTEM + '/' + ApiPaths.SYSTEM_ROLE,
    [ObjectTypes.SERVER]: ApiPaths.SYSTEM + '/' + ApiPaths.SERVER,
    [ObjectTypes.SERVER_GROUP]: ApiPaths.SYSTEM + '/' + ApiPaths.SERVER_GROUP,
    [ObjectTypes.SYSTEM_LOGS]: ApiPaths.LOGS + '/' + ApiPaths.SYSTEM_LOGS,
    [ObjectTypes.ACTIVITY_LOGS]: ApiPaths.LOGS + '/' + ApiPaths.ACTIVITY_LOGS
}

export const FilterTypes = {
    is: 'is',
    not: 'not',
    contains: 'contains',
    none: 'none'
}

export const ApiActions = {
    gateway: {
        resetToPlan: 'reset-to-plan',
        moveToPlan: 'move-to-plan',
        reboot: 'reboot',
        fetch: 'fetch',
        backup: 'backup',
        sendDailyReport: 'send-daily-report',
        sendWeeklyReport: 'send-weekly-report',
        sendMonthlyReport: 'send-monthly-report'
    },
    community: {
        generateTopology: 'generate-topology'
    }
}

export const ApiErrorCodes = {
    GENERAL_ERROR: 'GENERAL_ERROR',
    DATABASE_ERROR: 'DATABASE_ERROR',
    CONNECTION_ERROR: 'CONNECTION_ERROR',
    USER_OR_PASSWORD_INVALID: 'USER_OR_PASSWORD_INVALID',
    INPUT_OUTPUT_ERROR: 'INPUT_OUTPUT_ERROR',
    LOGIN_ERROR: 'LOGIN_ERROR',
    UNAUTHORIZED_REQUEST_ERROR: 'UNAUTHORIZED_REQUEST_ERROR',
    INVALID_SESSION_ERROR: 'INVALID_SESSION_ERROR',
    NO_CONTAINERS_FOR_USER: 'NO_CONTAINERS_FOR_USER',
    USER_UNAUTHORIZED_FOR_ACTION: 'USER_UNAUTHORIZED_FOR_ACTION',
    LOGOUT_ERROR: 'LOGOUT_ERROR',
    SESSION_EXPIRED_ERROR: 'SESSION_EXPIRED_ERROR',
    GW_MISSING_CONTAINER: 'GW_MISSING_CONTAINER',
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    CSRF_ERROR: 'CSRF_ERROR',
    AUTHENTICATION_SERVICE_ERROR: 'AUTHENTICATION_SERVICE_ERROR',
    TOO_MANY_LOGINS: 'TOO_MANY_LOGINS',
    PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',
    IP_UNAUTHORIZED_FOR_API: 'IP_UNAUTHORIZED_FOR_API',
    BAD_JSON: 'BAD_JSON',
    INVALID_SERVICE_DOMAIN: 'INVALID_SERVICE_DOMAIN',
    INVALID_GATEWAY: 'INVALID_GATEWAY',
    FIELD_ERROR: 'FIELD_ERROR',
    CREATE_ERROR: 'CREATE_ERROR',
    BAD_JSON_TO_OBJ: 'BAD_JSON_TO_OBJ',
    USER_EXPIRED: 'USER_EXPIRED',
    USER_LOCKED: 'USER_LOCKED',
    CAPTCHA_NOT_VERIFIED: 'CAPTCHA_NOT_VERIFIED',
    DOMAIN_DOESNT_EXIST: 'DOMAIN_DOESNT_EXIST',
    PASSWORD_INVALID: 'PASSWORD_INVALID',
    OBJ_EXISTS: 'OBJ_EXISTS',
    OBJ_NOT_EXISTS:'OBJ_NOT_EXISTS'
}

export const ApiErrorDataSchema = {
    illegalFields: 'illegalFields'
}

export const ErrorCodes = {
    SERVER_ERROR: 'SERVER_ERROR'
}